document.addEventListener("DOMContentLoaded", () => {
  actualizarContadorCarrito();
});

function actualizarContadorCarrito() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const contador = document.getElementById('carrito-contador');
      if (!contador) return;

      if (cart.item_count > 0) {
        contador.textContent = cart.item_count;
        contador.style.display = 'flex';
      } else {
        contador.style.display = 'none';
      }
    });
}

/* Detectar cuando se agrega un producto (AJAX o normal) */
document.addEventListener('click', function (e) {
  if (
    e.target.closest('button[name="add"]') ||
    e.target.closest('input[name="add"]')
  ) {
    setTimeout(actualizarContadorCarrito, 800);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  actualizarContadorCarrito();

  document.body.addEventListener("submit", function (e) {
    const form = e.target;

    // Detectar formulario de añadir al carrito
    if (form.querySelector('button[name="add"]')) {
      e.preventDefault();

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(res => res.json())
      .then(() => {
        actualizarContadorCarrito();
        animarCarrito();
      })
      .catch(err => console.error('Error al añadir al carrito:', err));
    }
  });
});

function actualizarContadorCarrito() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const contador = document.getElementById('carrito-contador');
      if (!contador) return;

      if (cart.item_count > 0) {
        contador.textContent = cart.item_count;
        contador.style.display = 'flex';
      } else {
        contador.style.display = 'none';
      }
    });
}

function animarCarrito() {
  const carrito = document.querySelector('.carrito-flotante');
  if (!carrito) return;

  carrito.classList.add('shake');
  setTimeout(() => carrito.classList.remove('shake'), 500);
}
